export default __webpack_public_path__ + "static/media/selenium-2.880d98bd.svg";